import React, { useState } from 'react'
import moment from 'moment'
import { Paper, Stack, Typography, Grid, Button } from '@mui/material'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import PupilSize from './PupilSize'
import ReactionToLight from './ReactionToLight'
import EyelidAssessment from './EyelidAssessment'
import Conjunctiva from './Conjunctiva'
import Sclera from './Sclera'
import Cornea from './Cornea'
import FluoresceinUptake from './FluoresceinUptake'

const Eyes = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Stack gap={2} padding={1} component={Paper}>
      <Grid container spacing={2} alignItems={2}>
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Eyes Assessment</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        {['Left', 'Right'].map((x) => (
          <Grid key={x} item xs={12} lg={6} container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="title2" fontSize="1rem">
                {x}
              </Typography>
            </Grid>
            <PupilSize
              moduleValues={moduleValues}
              setModuleValues={setModuleValues}
              side={x}
            />
            <ReactionToLight
              moduleValues={moduleValues}
              setModuleValues={setModuleValues}
              side={x}
            />
            <EyelidAssessment
              moduleValues={moduleValues}
              setModuleValues={setModuleValues}
              side={x}
            />
            <Conjunctiva
              moduleValues={moduleValues}
              setModuleValues={setModuleValues}
              side={x}
            />
            <Sclera
              moduleValues={moduleValues}
              setModuleValues={setModuleValues}
              side={x}
            />
            <Cornea
              moduleValues={moduleValues}
              setModuleValues={setModuleValues}
              side={x}
            />
            <FluoresceinUptake
              moduleValues={moduleValues}
              setModuleValues={setModuleValues}
              side={x}
            />
          </Grid>
        ))}
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Eyes', moduleValues)}
            variant="contained"
            color="success"
            fullWidth
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default Eyes
